import { render, staticRenderFns } from "./grossing-touch-protocols-sidepanel.vue?vue&type=template&id=016c4aa8&scoped=true&"
import script from "./grossing-touch-protocols-sidepanel.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-protocols-sidepanel.ts?vue&type=script&lang=ts&"
import style0 from "./grossing-touch-protocols-sidepanel.scss?vue&type=style&index=0&id=016c4aa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016c4aa8",
  null
  
)

export default component.exports